
<nav :class="{ open: navOpen }">
  <div class="logo">
    <full-logo pro />
  </div>

  <nav-item
    as="router-link"
    to="/dashboard"
    icon="space_dashboard"
    text="Dashboard"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/collection"
    icon="view_carousel"
    text="Collection"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    :to="`/sales-history?${salesHistoryQuery}`"
    icon="search"
    text="Sales"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/shop"
    icon="local_offer"
    text="Shop"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/ladder"
    icon="cl_ladder"
    text="Ladder"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/profiles"
    icon="badge"
    text="Profiles"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/showcase"
    icon="public"
    text="Showcase"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/indexes"
    icon="assessment"
    text="Indexes"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/players"
    icon="sports_handball"
    text="Players"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/watchlist"
    icon="visibility"
    text="Watchlist"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/compare"
    icon="multiline_chart"
    text="Compare"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/feed"
    icon="rss_feed"
    text="Feed"
    :collapsed="navCollapsed"
  />

  <nav-item
    as="router-link"
    to="/industry"
    icon="medical_services"
    text="Industry"
    :collapsed="navCollapsed"
  />

  <nav-item
    v-if="isStaff"
    admin
    as="router-link"
    to="/add"
    icon="verified"
    text="Verify"
    :collapsed="navCollapsed"
  />

  <nav-item
    v-if="isAdmin"
    admin
    as="router-link"
    to="/headlines"
    icon="newspaper"
    text="Headlines"
    :collapsed="navCollapsed"
  />

  <nav-item
    v-if="isStaff"
    admin
    as="router-link"
    to="/pending-sales"
    icon="nights_stay"
    text="Review"
    :collapsed="navCollapsed"
  />

  <nav-item
    v-if="isAdmin"
    admin
    as="router-link"
    to="/admin"
    icon="people"
    text="Admin"
    :collapsed="navCollapsed"
  />

  <nav-item
    class="collapse-toggle medium-up"
    as="button"
    :icon="navCollapsed ? 'last_page' : 'first_page'"
    text="Collapse"
    :collapsed="navCollapsed"
    @click="toggleCollapsed"
  />
</nav>
